module.exports = __webpack_public_path__ + "static/media/team-6.b73ccafc.webp";